import { Action, createReducer, on } from '@ngrx/store';

import * as DataAccessTogglesActions from './data-access-toggles.actions';

import { FeatureFlagToggleList } from '../../interface/feature-flags.interfaces';

export const DATA_ACCESS_TOGGLES_FEATURE_KEY = 'dataAccessToggles';

export interface DataAccessTogglesPartialState {
  readonly [DATA_ACCESS_TOGGLES_FEATURE_KEY]: FeatureFlagToggleList;
}

export const initialTogglesState: FeatureFlagToggleList = {};

const dataAccessTogglesReducer = createReducer(
  initialTogglesState,
  on(DataAccessTogglesActions.updated, (_, toggles) => ({
    ...toggles,
    type: undefined,
  }))
);

export function togglesReducer(state: FeatureFlagToggleList | undefined, action: Action) {
  return dataAccessTogglesReducer(state, action);
}
